import { ReactElement } from 'react';
import i18n from 'i18next';
import { AppTabs, TabModel } from 'components/AppTabs/AppTabs';
import { LoadType, SpansAndLoads } from 'types/domainTypes';
import { isLoadEmpty } from './SpansAndLoadsView';

interface LoadTabsProps {
  tabValue: LoadType;
  onTabChange: (newValue: LoadType) => void;
  isWallCalculation: boolean;
  spansAndLoads?: SpansAndLoads;
}

export function LoadTabs({ tabValue, onTabChange, isWallCalculation, spansAndLoads }: LoadTabsProps): ReactElement {
  const loadTabs: TabModel<LoadType>[] = [
    {
      label: i18n.t('calculation-page.label-permanent-load'),
      value: LoadType.PermanentLoad,
      display: spansAndLoads ? !isLoadEmpty(spansAndLoads.permanentLoads) : true,
    },
    {
      label: i18n.t('calculation-page.label-snow-load'),
      value: LoadType.SnowLoad,
      display: spansAndLoads ? !isLoadEmpty(spansAndLoads.snowLoads) : true,
    },
    {
      label: i18n.t('calculation-page.label-pressure-wind-load'),
      value: LoadType.PressureLoad,
      display: spansAndLoads ? !isLoadEmpty(spansAndLoads.pressureLoads) : true,
    },
    {
      label: i18n.t('calculation-page.label-suction-load'),
      value: LoadType.SuctionLoad,
      display: spansAndLoads ? !isLoadEmpty(spansAndLoads.suctionLoads) : true,
    },
    {
      label: i18n.t('calculation-page.label-imposed-load'),
      value: LoadType.ImposedLoad,
      display: spansAndLoads ? !isLoadEmpty(spansAndLoads.imposedLoads) : true,
    },
    {
      label: i18n.t('calculation-page.label-construction-load'),
      value: LoadType.ConstructionLoad,
      display: spansAndLoads ? !isLoadEmpty(spansAndLoads.constructionLoads) : true,
    },
    {
      label: i18n.t('calculation-page.label-excep-snow-load'),
      value: LoadType.ExcepSnowLoad,
      display: spansAndLoads ? !isLoadEmpty(spansAndLoads.excepSnowLoads) : true,
    },
  ];

  return (
    <AppTabs
      tabs={
        isWallCalculation ? loadTabs.filter(({ value }) => value === LoadType.PressureLoad || value === LoadType.SuctionLoad) : loadTabs
      }
      activeTab={tabValue}
      onTabChange={onTabChange}
      data-testid="load-tabs"
    />
  );
}
